import * as React from 'react'
import { cn } from '@/lib/utils'

/*
 * Renders a figure that animates once when its value changes (VIS-257): a brief
 * highlight that fades out, with no layout change. The value uses tabular-nums
 * and the element keeps its box, so a polled update never reflows the page or
 * moves the module. The highlight is gated behind motion-safe so users who
 * prefer reduced motion simply see the new value.
 */
export function AnimatedNumber({
  value,
  format,
  className,
}: {
  value: number
  format?: (value: number) => string
  className?: string
}) {
  const [flash, setFlash] = React.useState(false)
  const previous = React.useRef(value)

  React.useEffect(() => {
    if (previous.current === value) return
    previous.current = value
    setFlash(true)
    const timeout = setTimeout(() => setFlash(false), 900)
    return () => clearTimeout(timeout)
  }, [value])

  return (
    <span
      className={cn(
        'inline-block rounded-sm tabular-nums motion-safe:transition-colors motion-safe:duration-700',
        flash ? 'motion-safe:bg-selected' : 'bg-transparent',
        className,
      )}
    >
      {format ? format(value) : value}
    </span>
  )
}
